module.exports = __webpack_public_path__ + "static/media/button-loading.afa07036.svg";